const convertS3ImageUrl = (url, edits) => {
    try {
        if (url.slice(-4) === ".gif") return url;
        const cloudFrontHost = "d1wf6mq4nwilrh.cloudfront.net";
        const cloudFrontUrl = "https://d1wf6mq4nwilrh.cloudfront.net";
        let obj = new URL(url);
        let { pathname, host, hostname, origin } = obj;
        if (host === cloudFrontHost || hostname === cloudFrontHost || origin === cloudFrontUrl) return url;
        if (host !== 'fixedopsdigital.s3.amazonaws.com' && host !== 'fixedopsdigital.s3.us-east-1.amazonaws.com') return url;
        const imageRequest = JSON.stringify({
            bucket: "fixedopsdigital",
            key: pathname
                .substring(1)
                .replaceAll("%20", " ")
                .replaceAll("+", " ")
                .replaceAll("%E2%80%94", "–"),
            edits,
        });
        return `${cloudFrontUrl}/${window.btoa(imageRequest)}`;
    } catch {
        return url;
    }
};

export default convertS3ImageUrl;
